let html = `<svg width="161" height="277" viewBox="0 0 161 277" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.312012" y="0.291138" width="160.467" height="220.29" rx="7" fill="currentColor" fill-opacity="0.68"/>
    <rect x="0.312012" y="241.568" width="127.73" height="12.9024" rx="6.45122" fill="currentColor" fill-opacity="0.67"/>
    <rect x="0.312012" y="265.606" width="31.9717" height="11.0625" rx="5.53127" fill="currentColor" fill-opacity="0.47"/>
</svg>`

export default html